import { memo } from 'react'
import Link from 'next/link'

export const ColumnBanner = memo(() => {
  return (
    <div className="flex flex-col gap-6">
      <Link
        href={'/request/'}
        className={'block transition-opacity hover:opacity-80'}
      >
        <img
          src={'/images/banner-column.webp'}
          srcSet={
            '/images/banner-column.webp 1x, /images/banner-column@2x.webp 2x'
          }
          alt={'資料請求ダウンロード'}
        />
      </Link>
      <Link
        href={'/demo/'}
        className={'transition-opacity hover:opacity-80 hidden lg:block'}
      >
        <img
          src={'/images/banner-column02.webp'}
          srcSet={
            '/images/banner-column02.webp 1x, /images/banner-column02@2x.webp 2x'
          }
          alt={'今すぐライブデモを試す'}
        />
      </Link>
    </div>
  )
})

ColumnBanner.displayName = 'ColumnBanner'
